import {
  ACCESS_TOKEN_NAME,
  JSON_CONTENT_TYPE,
} from '../../_constant/constants';
import { ReestrPaymentInfo } from '../../_dto/_reestr/ReestrPaymentInfoDto';
import { IApiParams } from '../../_interface/IApiParams';
import { getApi } from '../getApi';

export const apiUpdateReestrPayment = async (dto: ReestrPaymentInfo) => {
  const params: IApiParams = {
    url: '/reestr/updateReestrPayment.php',
    headers: {
      'Content-Type': JSON_CONTENT_TYPE,
      'Access-Token': localStorage.getItem(ACCESS_TOKEN_NAME),
    },
  };
  return getApi(params, 'PUT', dto);
};
